"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePageInfo = exports.checkPaginationQueryParams = exports.getPageResult = void 0;
const Pagination_1 = require("./Pagination");
/**
 * Formats a given pagination page to the Shopify REST pagination convention.
 * https://shopify.dev/api/usage/pagination-rest
 * @param context The Koa context for this requests used to attach link response headers.
 * @param page The input page containing the page data.
 * @param endCursorGenerator A function which retuns the "end" cursor of a page of a given
 * list of nodes. "End" here means next or previous cursor, depending on the direction.
 * This function should return the value as plain text and not encoded, since base64 encoding is
 * done by the caller.
 * @returns Returns the nodes of the page.
 */
function getPageResult(context, page, endCursorGenerator, startCursorGenerator) {
    const links = [];
    const isFirstRequest = !context.query.page_info;
    const endCursor = endCursorGenerator(page.nodes);
    const startCursor = startCursorGenerator(page.nodes);
    if (endCursor && page.hasMore) {
        const link = createPageLink(context.URL.origin, context.URL.pathname, page.limit);
        link.searchParams.append("page_info", 
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, Pagination_1.encodeBase64Url)(JSON.stringify({
            ...page.queryParams,
            cursor: endCursor,
            direction: page.direction === "forward" ? "forward" : "backward",
        })));
        links.push(link);
    }
    else {
        links.push(null);
    }
    if (startCursor && !isFirstRequest) {
        const link = createPageLink(context.URL.origin, context.URL.pathname, page.limit);
        link.searchParams.append("page_info", 
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, Pagination_1.encodeBase64Url)(JSON.stringify({
            ...page.queryParams,
            cursor: startCursor,
            direction: page.direction === "forward" ? "backward" : "forward",
        })));
        links.push(link);
    }
    else {
        links.push(null);
    }
    if (page.direction === "backward") {
        page.nodes.reverse();
        links.reverse();
    }
    const headerLinks = [];
    if (links[0]) {
        headerLinks.push(`<${links[0].href}>; rel="next"`);
    }
    if (links[1]) {
        headerLinks.push(`<${links[1].href}>; rel="previous"`);
    }
    if (headerLinks.length > 0) {
        context.response.set("Link", headerLinks.join(", "));
    }
    return page.nodes;
}
exports.getPageResult = getPageResult;
function createPageLink(origin, pathname, limit) {
    const link = new URL(origin);
    link.pathname = pathname;
    link.searchParams.append("limit", limit.toString());
    return link;
}
function checkPaginationQueryParams(queryParams = {}) {
    if (queryParams["page_info"]) {
        return !Object.keys(queryParams)
            .filter((param) => !["limit", "page_info"].includes(param))
            .some((param) => !!queryParams[param]);
    }
    return true;
}
exports.checkPaginationQueryParams = checkPaginationQueryParams;
function parsePageInfo(pageInfo) {
    const queryParams = JSON.parse(Buffer.from(pageInfo, "base64url").toString("utf8"));
    const cursor = queryParams.cursor;
    const direction = queryParams.direction;
    delete queryParams.cursor;
    delete queryParams.direction;
    return {
        queryParams,
        cursor,
        direction,
    };
}
exports.parsePageInfo = parsePageInfo;
//# sourceMappingURL=RESTPagination.js.map